<template>
    <div>
        <div class="w-full flex justify-between border-b-gray-500 text-gray-500 tracking-widest">
            <div>
                City
            </div>
            <div><span class="text-4xl text-yellow-600" v-if="hasUnsavedChanges">•</span></div>
        </div>
        <div v-if="isEditable" class="flex justify-between items-center pl-2">
            <input @change="updateCity" type="text" v-model="city" class="border p-1 m-1 w-full">
        </div>
        <div class="pl-2" v-else>
            <div class="p-1">
                {{ calculatedCity }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';

const props = defineProps([
    'company',
    'isEditable'
])

const emit = defineEmits(['update-city'])

const calculatedCity = computed(() => {
    if(props.company) {
        return props.company.city
    } else {
        return null
    }
})

const city = ref(props.company ? props.company.city : null)

watch(calculatedCity, () => {
    city.value = calculatedCity.value
})

const hasUnsavedChanges = computed(() => {
    return props.company && props.company.original_city != props.company.city
})

function updateCity(){
    emit('update-city', city.value)
}


</script>